/** Stock / inventory permission strings (mirror backend PermissionCatalog). */
export const StockPermissions = {
  request: 'stock_request',
  selfRequest: 'stock_self_request',
  requestApprove: 'stock_request_approve',
  purchasePrepare: 'stock_purchase_prepare',
  purchaseApprove: 'stock_purchase_approve',
  issue: 'stock_issue',
  manage: 'stock_manage',
  reorderManage: 'stock_reorder_manage',
  inventoryAdjust: 'stock_inventory_adjust',
  dashboardRead: 'stock_dashboard_read',
  billingManage: 'stock_billing_manage',
  approvalAdmin: 'stock_approval_admin',

  /** Any stocks workspace page (read or operate). */
  access: [
    'stock_dashboard_read',
    'stock_request',
    'stock_self_request',
    'stock_request_approve',
    'stock_purchase_prepare',
    'stock_purchase_approve',
    'stock_issue',
    'stock_manage',
    'stock_reorder_manage',
    'stock_inventory_adjust',
    'stock_billing_manage',
    'stock_approval_admin',
  ] as const,

  /**
   * Ops / admin stocks workspace under Admin nav.
   * Excludes stock_self_request so supervisors only get Material request.
   */
  workspaceAccess: [
    'stock_dashboard_read',
    'stock_request',
    'stock_request_approve',
    'stock_purchase_prepare',
    'stock_purchase_approve',
    'stock_issue',
    'stock_manage',
    'stock_reorder_manage',
    'stock_inventory_adjust',
    'stock_billing_manage',
    'stock_approval_admin',
  ] as const,

  dashboardAccess: ['stock_dashboard_read', 'stock_manage'] as const,
  requisitionAccess: ['stock_request', 'stock_self_request', 'stock_manage'] as const,
  approvalAccess: ['stock_request_approve', 'stock_approval_admin', 'stock_manage'] as const,
  /**
   * Stock Approvals workspace (admin decide + visibility).
   * Approvers can open this without stock_dashboard_read.
   */
  adminApprovalsAccess: [
    'stock_request_approve',
    'stock_purchase_approve',
    'stock_approval_admin',
    'stock_manage',
  ] as const,
  fulfilmentAccess: ['stock_issue', 'stock_manage'] as const,
  procurementAccess: ['stock_purchase_prepare', 'stock_purchase_approve', 'stock_manage'] as const,
  alertsAccess: ['stock_reorder_manage', 'stock_dashboard_read', 'stock_manage'] as const,
  billingAccess: ['stock_billing_manage', 'stock_manage'] as const,
} as const
